import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";

type FlatResourceLineProps = {
  resource: any;
  onEdit?: Function;
  onDelete?: Function;
  children: ReactNode;
};

const FlatResourceLine = ({
  resource,
  onEdit,
  onDelete,
  children,
}: FlatResourceLineProps) => {
  return (
    <div className="InsuranceLine">
      <span>{children}</span>
      <div className="InsuranceLine__actions">
        {onEdit && (
          <FontAwesomeIcon
            icon="pencil-alt"
            onClick={() => {
              onEdit && onEdit(resource);
            }}
          />
        )}
        {onDelete && (
          <FontAwesomeIcon
            icon="trash"
            onClick={() => {
              onDelete(resource.id);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default FlatResourceLine;
